// index.js

import { combineReducers } from 'redux';
import AppReducer from './AppReducer';
import {reducer as toastrReducer} from 'react-redux-toastr';

export default combineReducers({
  AppReducer,
  toastr: toastrReducer 
})